import {Injectable} from '@angular/core';
import {Blog} from './blog';
import {Observable} from 'rxjs';
import {AngularFirestore, AngularFirestoreCollection} from 'angularfire2/firestore';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  const;
  whitespace = /\s+/g;
  private blogsCollection: AngularFirestoreCollection<any>;

  constructor(private afs: AngularFirestore) {
    this.blogsCollection = afs.collection('blogs', (ref) => ref.orderBy('createdAt', 'desc').limit(30));
  }

  getBlogs(): Observable<Blog[]> {
    return this.blogsCollection.valueChanges();
  }

  getData(): Observable<any[]> {
    return this.blogsCollection.snapshotChanges()
      .pipe(map(actions => actions.map(a => {
          const data = a.payload.doc.data() as Blog;
          const id = a.payload.doc.id;
          return {id, ...data};
        }))
      );
  }

  getBlogBySlug(id: string) {
    return this.afs.collection('blogs', ref => ref.where('summary', '==', `<p>Yeah, my simple blog is working fine now</p>`));
  }

  get(id: string) {
    return this.afs.doc<any>(`blogs/${id}`);
  }

  slugger(string, opts) {
    opts = opts || (opts = {});
    let allowedCharacters = 'A-Za-z0-9_ -';
    if (opts.alsoAllow) {
      allowedCharacters = opts.alsoAllow + allowedCharacters;
    }
    const re = new RegExp('[^' + allowedCharacters + ']', 'g');
    const maintainCase = opts.maintainCase || false;
    const replacement = opts.replacement || '-';
    const smartTrim = opts.smartTrim;
    const decode = (opts.decode !== false);
    let result;
    let lucky;

    if (typeof string !== 'string') {
      return '';
    }
    if (!maintainCase) {
      string = string.toLowerCase();
    }
    if (decode) {
      string = decodeURIComponent(string);
    }
    result = string.trim().replace(re, '').replace(this.whitespace, replacement);
    if (smartTrim && result.length > smartTrim) {
      lucky = result.charAt(smartTrim) === replacement;
      result = result.slice(0, smartTrim);
      if (!lucky) {
        result = result.slice(0, result.lastIndexOf(replacement));
      }
    }
    return result;
  }

  create(blog: Blog) {
    blog.slug = this.slugger(blog.title, null);
    const res = JSON.stringify(blog);
    const obj = JSON.parse(res);
    this.blogsCollection.add(obj);
  }

  update(id: string, data: any) {
    return this.get(id).update(data);
  }

  delete(id: string) {
    return this.get(id).delete();
  }
}
